import React from 'react';
import { StatusCell } from '../components/StatusCell';
import hasAccess, { controlChargerTaskAccessId, createChargerTaskAccessId } from '../services/HasAccess';

export const DIAGNOSTICS_CHARGER_TASK_TYPE = 'COLLECT_DIAGNOSTICS';

export const CHARGER_TASK_TYPES = [
  DIAGNOSTICS_CHARGER_TASK_TYPE,
];

export const CHARGER_TASK_TYPE_VALUE_LABEL_MAP = {
  [DIAGNOSTICS_CHARGER_TASK_TYPE]: 'Diagnostics',
};

export const CHARGER_TASK_TYPE_LABEL_VALUE_LIST = Object.keys(CHARGER_TASK_TYPE_VALUE_LABEL_MAP)
  .map((value) => ({ value, label: CHARGER_TASK_TYPE_VALUE_LABEL_MAP[value] }));

export const PENDING_CHARGER_TASK_STATUS = 'PENDING';
export const CANCELED_CHARGER_TASK_STATUS = 'CANCELED';
export const IN_PROGRESS_CHARGER_TASK_STATUS = 'IN_PROGRESS';
export const COMPLETED_CHARGER_TASK_STATUS = 'COMPLETED';
export const UPLOADING_CHARGER_TASK_STATUS = 'UPLOADING';
export const UNRESPONSIVE_CHARGER_TASK_STATUS = 'UNRESPONSIVE';
export const DONE_CHARGER_TASK_STATUS = 'DONE';
export const ERROR_CHARGER_TASK_STATUS = 'ERROR';

export const CHARGER_TASK_STATUSES = [
  PENDING_CHARGER_TASK_STATUS,
  CANCELED_CHARGER_TASK_STATUS,
  IN_PROGRESS_CHARGER_TASK_STATUS,
  COMPLETED_CHARGER_TASK_STATUS,
  UPLOADING_CHARGER_TASK_STATUS,
  DONE_CHARGER_TASK_STATUS,
  ERROR_CHARGER_TASK_STATUS,
  UNRESPONSIVE_CHARGER_TASK_STATUS,
];

export const CHARGER_TASK_STATUS_VALUE_LABEL_MAP = {
  [PENDING_CHARGER_TASK_STATUS]: 'Pending',
  [CANCELED_CHARGER_TASK_STATUS]: 'Canceled',
  [IN_PROGRESS_CHARGER_TASK_STATUS]: 'In progress',
  [COMPLETED_CHARGER_TASK_STATUS]: 'Retrieval Completed',
  [UPLOADING_CHARGER_TASK_STATUS]: 'Uploading',
  [DONE_CHARGER_TASK_STATUS]: 'Upload Completed',
  [ERROR_CHARGER_TASK_STATUS]: 'Error',
  [UNRESPONSIVE_CHARGER_TASK_STATUS]: 'Unresponsive',
};

export const CHARGER_TASK_STATUS_LABEL_VALUE_LIST = Object.keys(CHARGER_TASK_STATUS_VALUE_LABEL_MAP)
  .map((value) => ({
    value,
    label: (
      <StatusCell
        labelClassName={`c_task_status-label-${value.toLowerCase()}`}
        labelText={CHARGER_TASK_STATUS_VALUE_LABEL_MAP[value]}
        inDropdown
      />
    )
  }));

export const CANCEL_TASK_ACTION = 'CANCEL';
export const UPLOAD_TASK_ACTION = 'UPLOAD';
export const RETRY_TASK_ACTION = 'RETRY';
export const DOWNLOAD_TASK_ACTION = 'DOWNLOAD';

export const CHARGER_TASK_STATUS_ACTION_MAP = {
  [PENDING_CHARGER_TASK_STATUS]: (permissions) => {
    const actions = [];

    if (hasAccess(createChargerTaskAccessId, permissions)) actions.push(CANCEL_TASK_ACTION);
    if (hasAccess(createChargerTaskAccessId, permissions)) actions.push(RETRY_TASK_ACTION);

    return actions;
  },
  [IN_PROGRESS_CHARGER_TASK_STATUS]: (permissions) => {
    const actions = [];

    if (hasAccess(createChargerTaskAccessId, permissions)) actions.push(RETRY_TASK_ACTION);

    return actions;
  },
  [COMPLETED_CHARGER_TASK_STATUS]: (permissions) => {
    const actions = [];

    if (hasAccess(controlChargerTaskAccessId, permissions)) actions.push(UPLOAD_TASK_ACTION);
    if (hasAccess(createChargerTaskAccessId, permissions)) actions.push(RETRY_TASK_ACTION);

    return actions;
  },
  [UPLOADING_CHARGER_TASK_STATUS]: (permissions) => {
    const actions = [];

    if (hasAccess(createChargerTaskAccessId, permissions)) actions.push(RETRY_TASK_ACTION);

    return actions;
  },
  [ERROR_CHARGER_TASK_STATUS]: (permissions) => {
    const actions = [];

    if (hasAccess(createChargerTaskAccessId, permissions)) actions.push(RETRY_TASK_ACTION);

    return actions;
  },
  [DONE_CHARGER_TASK_STATUS]: (permissions) => {
    const actions = [];

    if (hasAccess(controlChargerTaskAccessId, permissions)) actions.push(DOWNLOAD_TASK_ACTION);
    if (hasAccess(createChargerTaskAccessId, permissions)) actions.push(RETRY_TASK_ACTION);

    return actions;
  },
  [CANCELED_CHARGER_TASK_STATUS]: (permissions) => {
    const actions = [];

    if (hasAccess(createChargerTaskAccessId, permissions)) actions.push(RETRY_TASK_ACTION);

    return actions;
  },
  [UNRESPONSIVE_CHARGER_TASK_STATUS]: (permissions) => {
    const actions = [];

    if (hasAccess(createChargerTaskAccessId, permissions)) actions.push(RETRY_TASK_ACTION);

    return actions;
  },
};
